import React, { Fragment, PureComponent } from "react";
import { UISref } from "@uirouter/react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { Icon } from "../Common/Icon";
import { encodeViewStateForUrl } from "../../helpers/urlHelpers";
import {
  getCustomerSelector,
  getFirstBillOfLadingSelector,
  getFirstMillOrderSelector,
  getLoadSelector,
  getPurchaseOrderSelector
} from "../../selectors/selectors";

class Breadcrumb extends PureComponent {
  static propTypes = {
    onItemClick: PropTypes.func.isRequired,
    breadcrumbStack: PropTypes.array,
    currentBillOfLading: PropTypes.object,
    currentCustomer: PropTypes.object,
    currentLoad: PropTypes.object,
    currentMillOrder: PropTypes.object,
    currentPurchaseOrder: PropTypes.object,
    defaultBreadcrumbItems: PropTypes.array,
    routerParams: PropTypes.object,
    scrollStack: PropTypes.array
  };

  static defaultProps = {
    breadcrumbStack: [],
    currentBillOfLading: {},
    currentCustomer: {},
    currentLoad: {},
    currentMillOrder: {},
    currentPurchaseOrder: {},
    defaultBreadcrumbItems: [],
    routerParams: {},
    scrollStack: []
  };

  getBreadcrumbItems = () => {
    if (_.isEmpty(this.props.breadcrumbStack)) {
      return this.props.defaultBreadcrumbItems;
    }

    return [
      { to: "home", label: "breadcrumb.customers", icon: "home" },
      { to: "advanced-search", label: "advancedSearch" },
      ...this.props.breadcrumbStack.map(item => ({ to: item, label: item }))
    ];
  };

  getBreadcrumbLinkParams = routeName => {
    const { routerParams: scrollStackParams = {} } = this.props.scrollStack.find(scroll => scroll.routerStateName === routeName) || {};
    const { viewState, ...paramsWithoutViewState } = this.props.routerParams; // eslint-disable-line
    const breadcrumbLinkParams = { ...paramsWithoutViewState, ...encodeViewStateForUrl(scrollStackParams) };

    if (!_.isEmpty(breadcrumbLinkParams.breadcrumbStack)) {
      const routePosition = breadcrumbLinkParams.breadcrumbStack.indexOf(routeName);

      if (routePosition !== -1) {
        const copyArray = [...breadcrumbLinkParams.breadcrumbStack];
        copyArray.splice(routePosition + 1, copyArray.length - 1);
        breadcrumbLinkParams.breadcrumbStack = copyArray;
      }
    }

    return breadcrumbLinkParams;
  };

  getLabel = item => {
    const { currentBillOfLading, currentCustomer, currentLoad, currentMillOrder, currentPurchaseOrder } = this.props;

    return i18n.t(`breadcrumb.${item.label}`, {
      customerName: currentCustomer.customerName || i18n.t("breadcrumb.customer"),
      purchaseOrderId: currentPurchaseOrder.customerPOId || "",
      loadId: currentLoad.loadId || currentBillOfLading.loadId || currentMillOrder.loadId || "",
      shipmentId: currentBillOfLading.shipmentId || i18n.t("breadcrumb.shipment")
    });
  };

  render() {
    const breadcrumbItems = this.getBreadcrumbItems();

    return (
      <div className="secondary-navbar__breadcrumb">
        {breadcrumbItems.map((item, index) => {
          const params = this.getBreadcrumbLinkParams(item.to);
          const isLastItem = index === breadcrumbItems.length - 1;

          return (
            <Fragment key={item.to}>
              {item.icon &&
                breadcrumbItems.length > 1 && (
                  <UISref to={item.to} params={params}>
                    <Icon id={item.icon} className="secondary-navbar__breadcrumb-icon" onClick={this.props.onItemClick} />
                  </UISref>
                )}

              {isLastItem && breadcrumbItems.length > 1 && <span className="secondary-navbar__breadcrumb-item --active">{this.getLabel(item)}</span>}
              {!isLastItem && (
                <UISref to={item.to} params={params}>
                  {!item.icon ? (
                    <button onClick={this.props.onItemClick} className={classNames("secondary-navbar__breadcrumb-item")}>
                      {this.getLabel(item)}
                    </button>
                  ) : (
                    <div />
                  )}
                </UISref>
              )}

              {!isLastItem && <Icon className="secondary-navbar__breadcrumb-separator" id="arrow-down" />}
            </Fragment>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { customerId, customerPOId, breadcrumbStack, loadId } = state.app.routerParams;

  return {
    breadcrumbStack,
    routerParams: state.app.routerParams,
    defaultBreadcrumbItems: state.app.routerState.defaultBreadcrumbItems,
    currentBillOfLading: getFirstBillOfLadingSelector(state),
    currentCustomer: getCustomerSelector(state, customerId),
    currentLoad: getLoadSelector(state, loadId),
    currentMillOrder: getFirstMillOrderSelector(state),
    currentPurchaseOrder: getPurchaseOrderSelector(state, customerPOId)
  };
};

export default connect(
  mapStateToProps,
  {}
)(Breadcrumb);



// WEBPACK FOOTER //
// ./src/components/Layout/Breadcrumb.js